<!-- 录入合同 -->
<template>
    <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                        <a-form-item :label="$t('报装编号')">
                            <j-input :placeholder="$t('请输入报装编号')" v-model="queryParam.installationNum"></j-input>
                        </a-form-item>
                    </a-col>
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                        <a-form-item :label="$t('用户名称')">
                            <a-input :placeholder="$t('请输入用户名称')" v-model="queryParam.installationName"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                        <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                            <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                            <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                        </span>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator">
            <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
            <!-- <a-button type="primary" icon="download" @click="handleExportXls('construction_detail')">导出</a-button> -->
            <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
            <!-- 高级查询区域 -->
            <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
        </div>

        <!-- table区域-begin -->
        <div>
            <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

            <a-table ref="table" size="middle" :scroll="{x:true}" bordered rowKey="id" :columns="columns" :dataSource="dataSource" :pagination="ipagination" :loading="loading" class="j-table-force-nowrap" @change="handleTableChange">

                <template slot="htmlSlot" slot-scope="text">
                    <div v-html="text"></div>
                </template>
                <template slot="imgSlot" slot-scope="text,record">
                    <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
                    <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;" />
                </template>
                <template slot="fileSlot" slot-scope="text">
                    <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
                    <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
                        {{ $t('下载') }}
                    </a-button>
                </template>
                <!-- 报装编号 -->
                <span slot="installationNum" slot-scope="text, record">
                    <span>{{ text }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span @click.stop="copySampleNoLink(record.installationNum)" class="copySampleNo"><a-icon type="copy" /></span>
                </span>
                <span slot="action" slot-scope="text, record">
                    <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                    <!-- <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
                </span>

            </a-table>
        </div>

        <Modal ref="modalForm" @ok="modalFormOk"></Modal>
    </a-card>
</template>

<script>

import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Modal from './modules/modal.vue'
import JInput from '@/components/jeecg/JInput'
import {
    filterDictTextByMany,
    filterDictTextByCache
} from '@/components/dict/JDictSelectUtil';
import { httpAction, getAction, postAction } from '@/api/manage'

export default {
    name: 'enterContractList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
        Modal,
        JInput
    },
    data() {
        return {
            description: 'construction_detail管理页面',
            url: {
                list: "/jeecg-engineering/engineering/contractDetail/list",
                delete: "/jeecg-engineering/engineering/contractDetail/delete",
                deleteBatch: "/jeecg-engineering/engineering/contractDetail/deleteBatch",
                // exportXlsUrl: "/jeecg-engineering/engineering/contractDetail/exportXls",
                // importExcelUrl: "jeecg-engineering/engineering/contractDetail/importExcel",
            },
            dictOptions: {},
            superFieldList: [],
        }
    },
    created() { },
    computed: {
        importExcelUrl: function () {
            return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
        },
        // 表头
        columns() {
            return [
                {
                    title: '#',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 60,
                    align: "center",
                    customRender: (t, r, index) => {
                        return parseInt(index) + 1;
                    }
                },
                {
                    title: this.$t('报装编号'),
                    align: "center",
                    dataIndex: 'installationNum',
                    width: 320,
                    scopedSlots: { customRender: 'installationNum' },
                },
                {
                    title: this.$t('用户名称'),
                    align: "center",
                    dataIndex: 'installationName',
                    width: 150,
                    ellipsis: true,
                },
                {
                    title: this.$t('用户电话'),
                    align: "center",
                    dataIndex: 'installationPhone',
                    width: 150,
                    ellipsis: true,
                },
                {
                    title: this.$t('报装类型'),
                    align: "center",
                    dataIndex: 'installationType',
                    customRender: (text) => {
                        return filterDictTextByCache('installationType', text)
                    }
                },
                {
                    title: this.$t('合同名称'),
                    align: "center",
                    dataIndex: 'contractName'
                },
                {
                    title: this.$t('合同金额(元)'),
                    align: "center",
                    dataIndex: 'contractAmount'
                },
                {
                    title: this.$t('甲方'),
                    align: "center",
                    dataIndex: 'partyA'
                },
                {
                    title: this.$t('乙方'),
                    align: "center",
                    dataIndex: 'partyB'
                },
                // {
                //   title:'备注',
                //   align:"center",
                //   dataIndex: 'remark'
                // },
                // {
                //   title:'附件',
                //   align:"center",
                //   dataIndex: 'contractAnnex'
                // },
                {
                    title: this.$t('操作'),
                    dataIndex: 'action',
                    align: "center",
                    fixed: "right",
                    width: 147,
                    scopedSlots: { customRender: 'action' }
                }
            ]
        },
    },
    methods: {
        handleDetail(row) {
            this.$nextTick(() => {
                this.$refs.modalForm.init(row, 'detail');
            })
        }
    }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>